import React, { FC } from 'react';
import styled from 'styled-components';
import { SdirButton, styles } from '@sdir/sds';
import { Card } from '../../Atoms';

type ActionCardProps = {
  children: any;
  heading: string;
  onClick?: () => void;
  actionText?: string;
};

export const ActionCard: FC<ActionCardProps> = ({ children, heading, actionText, onClick }) => {
  return (
    <Card heading={heading} accent>
      <ActionCardContents>
        <div className="actioncard__contents">{children}</div>
        {onClick && <SdirButton text={actionText} type="primary" onClick={onClick} />}
      </ActionCardContents>
    </Card>
  );
};

const ActionCardContents = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 32px;

  .actioncard__contents {
    max-width: 520px;
    flex-grow: 0;
    flex-shrink: 1;
  }

  @media screen and (max-width: ${styles.screen.large}) {
    flex-direction: column;
    align-items: flex-start;

    .actioncard__contents {
      max-width: 392px;
    }
  }
`;
